<section class="section-title" [style.background-image]="backgroundImage">

  <div class="section-title-image">
    <img class="device-image" src="assets/img/alias.png" />
  </div>

  <div class="section-title-text">
    <h1 i18n="@@aliases_title">Operatori</h1>

  </div>

</section>

<section class="section-content">

  <div *ngIf="canUserEditAlias" class="buttons-container">

    <ng-container id="ownerAddAlias">
      <a (click)="addAlias()" id="ownerAddAlias" class="button">
        <ng-container i18n="@@alias_add_owner">Aggiungi operatore</ng-container> <span>
          <fa-icon icon="user"></fa-icon>
        </span>
      </a>
    </ng-container>
  </div>

  <div class="table-filter">
    <p i18n="@@aliases_filter">Filtra: </p>
    <input id="filter-input" (keyup)="onKey($event)" />
  </div>

  <div class="table-container">

    <table mat-table matSort #aliasestable class="simple-table">

      <ng-container matColumnDef="alias.email">
        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@aliases_alias_email" style="width: 45%;">Email
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.alias.email }} </td>
      </ng-container>

      <ng-container matColumnDef="publicName">
        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@aliasdetail_shown_name" style="width: 35%;">Nome
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.publicName }} </td>
      </ng-container>

      <ng-container matColumnDef="unlinkAlias">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <!-- <fa-icon icon="unlink" class="float-right padding-5 icon-clickable"  (click)="unlinkOwner(element)"></fa-icon> -->
          <fa-icon icon="chevron-right" class="float-right padding-5 icon-clickable"
            (click)="openAliasDetailPage(element)"></fa-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns;">
      </tr>

    </table>

  </div>

  <app-loading-screen #aliasesloader></app-loading-screen>

</section>